export default __webpack_public_path__ + "static/media/chat-alt.12953fe4.svg";